// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedMagnificationMinus_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s48IconSvg = html `<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#EF8354" d="M28 7H40V9H28z"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.3348 14.7785C28.6306 19.0742 28.6306 26.039 24.3348 30.3348C20.039 34.6306 13.0742 34.6306 8.77847 30.3348C4.4827 26.039 4.4827 19.0742 8.77847 14.7785C13.0742 10.4827 20.039 10.4827 24.3348 14.7785ZM22.9206 16.1927C26.4353 19.7074 26.4353 25.4059 22.9206 28.9206C19.4059 32.4353 13.7074 32.4353 10.1927 28.9206C6.67796 25.4059 6.67796 19.7074 10.1927 16.1927C13.7074 12.678 19.4059 12.678 22.9206 16.1927Z" class="svg-bg"/>
  <path d="M25.749 31.749C26.2963 31.2018 26.7887 30.6205 27.2264 30.012L33.5272 38.113L32.113 39.5272L24.012 33.2264C24.6205 32.7887 25.2018 32.2963 25.749 31.749Z" class="svg-bg"/>
</svg>
`;
const _s64IconSvg = html `<svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M34.4053 25.0205C39.4821 30.0973 39.4821 38.3285 34.4053 43.4053C29.3285 48.4821 21.0973 48.4821 16.0205 43.4053C10.9437 38.3285 10.9437 30.0973 16.0205 25.0205C21.0973 19.9437 29.3285 19.9437 34.4053 25.0205ZM35.8195 23.6063C41.6774 29.4642 41.6774 38.9616 35.8195 44.8195C29.9616 50.6774 20.4642 50.6774 14.6063 44.8195C8.74842 38.9616 8.74842 29.4642 14.6063 23.6063C20.4642 17.7484 29.9616 17.7484 35.8195 23.6063ZM37.2337 46.2337C37.899 45.5684 38.4976 44.8617 39.0295 44.1219L47.1332 54.719L45.719 56.1332L35.1219 48.0295C35.8617 47.4976 36.5684 46.899 37.2337 46.2337Z" class="svg-bg"/>
  <path fill="#EF8354" d="M40 13H56V16H40z"/>
</svg>
`;
/**
 * IconMedMagnificationMinus is a generated icon component.
 */
let IconMedMagnificationMinus = IconMedMagnificationMinus_1 = class IconMedMagnificationMinus extends IconBaseElement {
    render() {
        return html `${IconMedMagnificationMinus_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedMagnificationMinus.icons = new Map([
    ['s8', _s48IconSvg],
    ['s12', _s48IconSvg],
    ['s16', _s48IconSvg],
    ['s24', _s48IconSvg],
    ['s32', _s48IconSvg],
    ['s40', _s48IconSvg],
    ['s48', _s48IconSvg],
    ['s64', _s64IconSvg],
    ['s72', _s64IconSvg],
    ['s80', _s64IconSvg],
]);
IconMedMagnificationMinus = IconMedMagnificationMinus_1 = __decorate([
    customElement('zui-icon-med-magnification-minus')
], IconMedMagnificationMinus);
export { IconMedMagnificationMinus };
